import { render, staticRenderFns } from "./likeMenu.vue?vue&type=template&id=723f2aed&scoped=true&"
import script from "./likeMenu.vue?vue&type=script&lang=js&"
export * from "./likeMenu.vue?vue&type=script&lang=js&"
import style0 from "./likeMenu.vue?vue&type=style&index=0&id=723f2aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f2aed",
  null
  
)

export default component.exports